<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirm')+$t('lock')"
            @on-ok="showDelModal=false;lockUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('user')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6">
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_add_user" :title="$t('add')+$t('user')" @on-ok="add_user">
            <Form :model="modalAdd" :label-width="100">
                <FormItem :label="$t('username')">
                    <Input v-model="modalAdd.mobile"></Input>
                </FormItem>
                <FormItem :label="$t('password')">
                    <Input type="password" v-model="modalAdd.pass"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="show_edit_modal" :title="$t('edit')+$t('user')" @on-ok="editModalOk">
            <Form :model="modalEdit" :label-width="100">
                <FormItem :label="$t('username')">
                    <Input v-model="modalEdit.username"></Input>
                </FormItem>
                <FormItem :label="$t('mobile')">
                    <Input v-model="modalEdit.mobile"></Input>
                </FormItem>
                <FormItem :label="$t('email')">
                    <Input v-model="modalEdit.email"></Input>
                </FormItem>
                <FormItem :label="$t('level')">
                    <Select v-model="modalEdit.vip_level">
                        <Option value="1">vip1</Option>
                        <Option value="2">vip2</Option>
                        <Option value="3">vip3</Option>
                        <Option value="4">vip4</Option>
                        <Option value="5">vip5</Option>
                        <Option value="6">vip6</Option>
                        <Option value="7">vip7</Option>
                        <Option value="8">vip8</Option>
                        <Option value="9">vip9</Option>
                        <Option value="10">vip10</Option>
                    </Select>
                </FormItem>
                <FormItem label="余额">
                    <Input type="number" v-model="modalEdit.balance"></Input>
                </FormItem>
                <FormItem :label="$t('password')">
                    <Input type="password" v-model="modalEdit.password"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="show_edit_note_modal" :title="$t('edit')+$t('note')" @on-ok="editNoteModalOk">
            <Form :model="modalEditNote" :label-width="100">
                <FormItem :label="$t('note')">
                    <Input v-model="modalEditNote.note"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="show_del_modal" :title="$t('del')+$t('user')" @on-ok="delModalOk">
            <p>{{$t('confirmDel')}}</p>
        </Modal>
        <Modal v-model="show_message_modal" :title="$t('message')" @on-ok="sendMessage" @on-cancel="show_message_modal = false" okText="新增消息" >
            <!-- 消息记录 -->
            <Table border :columns="messageColumns" :data="messageData"></Table>
            <div class="page">
                <Page
                    :total="totalMessageItems"
                    :page-size="messageItemsPerPage"
                    show-elevator
                    :current="currentMessagePage"
                    @on-change="loadData"
                />
            </div>
            <Form :model="modalMessage" :label-width="100" style="margin-top: 10px;">
                <FormItem label="标题(可选)">
                    <Input v-model="modalMessage.title"></Input>
                </FormItem>
                <FormItem :label="$t('content')">
                    <Input type="textarea" :rows="5" v-model="modalMessage.content" placeholder="请输入内容"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>


<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';

export default {
    data() {
        return {
            showDelModal: false,
            show_update_credit: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            totalMessageItems: 0,
            messageItemsPerPage: 10,
            currentMessagePage: 1,
            itemsPerPage: 10,
            search: "",
            modalEditNote: {
                user_id: 0,
                note: ''
            },
            show_edit_note_modal: false,
            columns12: [
                {
                    title: "ID",
                    key: "user_id"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "username"
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 120,
                    key: "mobile"
                },
                {
                    title: 'Email',
                    width: 150,
                    key: "email",
                },
                {
                    title:this.$i18n.t('menu.inviteCode'),
                    key: "invite_code",
                },
                {
                    title:this.$i18n.t('note'),
                    key: "note",
                    render: (h, params) => {
                        return h('div',{style: {display: 'flex', alignItems: 'center'}}, [
                        h('span', params.row.note || '-'),
                            h('Icon', {
                            style: {backgroundColor: '', border: 'none'},
                            props: {
                                type: 'md-create',
                                size: 20,
                                color: 'blue'
                            },
                            on: {
                                click: () => {
                                    this.editNoteModal(params.row.user_id, params.row.note);
                                }
                            }
                        }),
                        ]);
                    }
                },
                {
                    title: this.$i18n.t('level'),
                    key: "vip_level",
                    // slot:"vip_level"
                },
                {
                    title: this.$i18n.t('lastLoginTime'),
                    width: 150,
                    key: "last_login_at",
                    render: (h, params) => {
                        return h('span', this.formatUTCTime(params.row.last_login_at));
                    }
                    // slot:"last_login_time"
                },
                {
                    title: '信用分',
                    key: "credit_score",
                    // slot:"is_verified"
                    render: (h, params) => {
                        return h('Input', {
                            props: {
                                type: 'number',
                                value: params.row.credit_score || 0
                            },
                            on: {
                                'on-blur': (e) => {
                                    this.editCreditScore(params.row.user_id, e.target.value)
                                }
                            }
                        });
                    }
                },
                {
                    title: '余额',
                    key: "balance",
                    width: 100,
                },
                {
                    title: this.$i18n.t('agent.agent'),
                    key: "agentName",
                },
                {
                    title: this.$i18n.t('edit'),
                    key: "edit",
                    render: (h, params) => {
                        return h('Icon',{
                            props: {
                                type: 'md-create',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'blue',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.editModal(params.row)  
                                }
                            }
                        }, this.$i18n.t('edit'));
                    }
                },
                {
                    title:this.$i18n.t('lock'),
                    key: "is_withdraw",
                    render: (h, params) => {
                        return h('Icon',{
                            props: {
                                type: params.row.is_withdraw == 1 ? 'md-lock' : 'md-unlock',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: params.row.is_withdraw == 1 ? 'red' : 'green',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.lockUser(params.row.user_id, params.row.is_withdraw)
                                }
                            }
                        });
                    }
                },
                {
                    title: this.$i18n.t('del'),
                    key: "del",
                    render: (h, params) => {
                        return h('Icon',{
                            props: {
                                type: 'md-trash',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'red',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.delModal(params.row.user_id)
                                }
                            }
                        }, this.$i18n.t('del'));
                    }
                },
                {
                    title: '站内信',
                    key: "message",
                    render: (h, params) => {
                        return h('Icon',{
                            props: {
                                type: 'md-mail',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'blue',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.showMessageModal(params.row.user_id)
                                }
                            }
                        });
                    }
                }
            ],
            data6: [],
            modalAdd: {
                mobile: "",
                pass: ""
            },
            modalEdit:{
                user_id:'',
                username:'',
                mobile:'',
                email:'',
                vip_level:'',
                password:'',
                balance:0
            },
            show_add_user: false,
            show_edit_modal:false,
            show_del_modal:false,
            show_message_modal:false,
            modalMessage: {
                user_id: 0,
                title: '',
                content: ''
            },
            messageColumns: [
                {
                    title: '标题',
                    key: 'title'
                },
                {
                    title: '内容',
                    key: 'content'
                },
                {
                    title: '状态',
                    key: 'is_show',
                    render: (h, params) => {
                        return h('span',{style:{color: params.row.is_show == 1 ? 'green' : 'red'}}, params.row.is_show == 1 ? '已读' : '未读',);
                    }
                },
                {
                    title: '时间',
                    key: 'created_at',
                    render: (h, params) => {
                        return h('span', this.formatUTCTime(params.row.created_at));
                    }
                }
            ],
            messageData: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        showMessageModal(user_id) {
            this.modalMessage.user_id = user_id;
            this.show_message_modal = true;
            this.loadMessageData(user_id);
        },
        loadMessageData(user_id) {
            this.$get(this.$path.msg, {
                user_id: user_id,
                page: this.currentMessagePage,
                page_size: this.messageItemsPerPage
            }).then(res => {
                if (res.data) {
                    this.messageData = res.data.list;
                    this.totalMessageItems = res.data.pageObj.totalSize;
                    this.messageItemsPerPage = res.data.pageObj.pageSize;
                }
                else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        sendMessage() {
            this.$post(this.$path.msg_add, {
                user_id: this.modalMessage.user_id,
                content: this.modalMessage.content,
                title: this.modalMessage.title,
                type:['message']
            }).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    // this.show_message_modal = false;
                    // this.loadMessageData(this.modalMessage.user_id);
                    this.modalMessage.title = '';
                    this.modalMessage.content = '';
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        // 去除对象中的空值（null, undefined, 空字符串）
        removeEmptyFields(obj) {
            const result = {};
            for (let key in obj) {
                const value = obj[key];
                // 跳过 null 和 undefined
                if (value === null || value === undefined) {
                    continue;
                }
                // 如果是字符串，去除前后空格后检查是否为空
                if (typeof value === 'string') {
                    const trimmed = value.trim();
                    if (trimmed !== '') {
                        result[key] = trimmed;
                    }
                } else {
                    // 非字符串类型直接保留
                    result[key] = value;
                }
            }
            return result;
        },
        loadData(page) {
            this.currentPage = page;
            // let path = this.search ? this.$path.user_search : this.$path.user;
            this.$get(this.$path.user, {
                mobile: this.search,
                page: this.currentPage,
                type: "user",
                search: this.search
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        lockUser(user_id,is_withdraw) {
            if(!confirm(this.$i18n.t('confirm')+this.$i18n.t('lock'))){
                return false;
            }
            this.$post(this.$path.user_lock, {
                user_id: user_id,
                is_withdraw:is_withdraw == 1 ? 0 : 1
            }).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(user_id) {
            this.userIdToDel = user_id;
            this.show_del_modal = true;
        },
        delModalOk(){
            this.$post(this.$path.user_del, {
                user_id: this.userIdToDel
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
                this.show_del_modal = false;
            });
        },
        add_user() {
            this.$post(this.$path.user_add, this.modalAdd).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalAdd = {
                        mobile:'',
                        pass:''
                    }
                }
            });
        },
        editModal(row){
            this.modalEdit.user_id = row.user_id;
            this.modalEdit.username = row.username;
            this.modalEdit.mobile = row.mobile;
            this.modalEdit.email = row.email;
            this.modalEdit.vip_level = row.vip_level;
            this.show_edit_modal = true;
        },
        editCreditScore(user_id, credit_score) {
            this.$post(this.$path.user_edit, {
                user_id: user_id,
                credit_score: Number(credit_score)
            }).then(res => {
                if (res.error_code == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
                else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        editModalOk(){
            // 构建数据对象，如果密码为空则不包含密码字段
            const submitData = { ...this.modalEdit };
            
            // 如果密码为空或只包含空格，则删除密码字段（避免后端将空密码保存）
            if (!submitData.password || (typeof submitData.password === 'string' && submitData.password.trim() === '')) {
                delete submitData.password;
            }
            
            // 去除所有空值字段（null, undefined, 空字符串）
            const data = this.removeEmptyFields(submitData);
            
            this.$post(this.$path.user_edit, data).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalEdit.username = '';
                    this.modalEdit.mobile = '';
                    this.modalEdit.email = '';
                    this.modalEdit.vip_level = '';
                    this.modalEdit.password = '';
                }
            });
        },
        editNoteModal(user_id, note) {
            this.modalEditNote.user_id = user_id;
            this.modalEditNote.note = note;
            this.show_edit_note_modal = true;
        },
        editNoteModalOk(){
            this.$post(this.$path.user_edit, this.modalEditNote).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
                else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
                this.modalEditNote.note = '';
            });
        },
        formatUTCTime(utcTimeString) {
            return formatUTC(utcTimeString, 8); // 使用东八区
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue